export default "__VITE_ASSET__b4ce1563__"